
import React from 'react';
import AdsPageLayout from '../Components/AdsPage/AdsPageLayout';
import { adsPageConfigs, commonComparisonData, commonAdvantages } from '../Components/AdsPage/adsData';
import schemaCesu from "../Assets/Images/SchemaFacturation/SchemaCESU.png";

export default function CesuPageAds() {
  const config = adsPageConfigs.cesu;
  
  // Données spécifiques pour cette page
  const comparisonData = [
    ...commonComparisonData.slice(0, 2), // Garde les 2 premiers éléments identiques
    {
      label: "Remboursement de 50% instantané",
      system: 0,
      aici: 1,
    },
    {
      label: "Avoir la main sur vos paiements",
      system: 0,
      aici: 1,
    },
    {
      label: "Vous ne gérez ni l'administratif ni la facturation",
      system: 1,
      aici: 1,
    },
  ];

  // Avantages spécifiques pour cette page
  const advantages = [
    {
      ...commonAdvantages[0],
      title: "Réduction des cotisations :",
      description: "Dites adieu aux 45% de cotisations sociales et patronales. Teach'r optimise vos revenus en réduisant vos charges, les faisant passer de 45% à 22%."
    },
    {
      ...commonAdvantages[1],
      description: "Finies les vérifications fastidieuses des paiements en fin de mois. Déclarez vous-même vos cours sur la plateforme Teach'r, rapidement et simplement."
    },
    {
      ...commonAdvantages[2],
      description: "Gardez la main sur vos paiements. Avec Teach'r, vous avez une vision claire et précise de vos revenus, à tout moment."
    }
  ];

  return (
    <AdsPageLayout
      {...config}
      comparisonData={comparisonData}
      advantages={advantages}
      currentSituationImage={schemaCesu}
    />
  );
}
